module.exports = __webpack_public_path__ + "img/banner.1535b47b.png";